import Phaser from "phaser";
import emblem from "../assets/phaser-market-pulse/emblem.png";
export { emblem as MARKET_EMBLEM };

/** The crafted instrument stays still. Only a tiny light travels over its copper rim.
 * No bouncing whole icon, halo or fake financial chart. Accessible copy stays in HTML.
 */
export function createMarketEmblem(parent: HTMLElement, reduced: boolean) {
  reduced ||= window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const ratio = Math.min(window.devicePixelRatio || 1, 2);
  class Emblem extends Phaser.Scene {
    art?: Phaser.GameObjects.Image;
    glint?: Phaser.GameObjects.Graphics;
    preload() { this.load.image("market-astrolabe", emblem); }
    create() {
      this.art = this.add.image(0, 0, "market-astrolabe");
      this.glint = this.add.graphics().fillStyle(0xffefc2).fillEllipse(-2, -1, 4, 2);
      this.layout(); this.scale.on("resize", () => this.layout());
      this.game.events.once(Phaser.Core.Events.POST_RENDER, () => { parent.dataset.emblemReady = "true"; });
    }
    layout() {
      const size = Math.min(this.scale.height * .94, this.scale.width * 256 / 223 * .95);
      this.art?.setPosition(this.scale.width / 2, this.scale.height / 2).setDisplaySize(size * 223 / 256, size);
    }
    override update(time: number) {
      if (!this.glint) return;
      const phase = time / 5000 % 1;
      const theta = phase * Math.PI * 2;
      this.glint.setVisible(!reduced).setScale(ratio)
        .setPosition(this.scale.width * (.5 + Math.sin(theta) * .33), this.scale.height * (.48 - Math.cos(theta) * .32))
        .setAlpha(reduced ? 0 : .5 * Math.sin(Math.PI * phase) ** 4);
    }
  }
  const canvas = document.createElement("canvas"); canvas.setAttribute("aria-hidden", "true");
  const scene = new Emblem(), game = new Phaser.Game({ type: Phaser.CANVAS, parent, canvas, transparent: true, banner: false,
    width: Math.max(1, parent.clientWidth * ratio), height: Math.max(1, parent.clientHeight * ratio), audio: { noAudio: true }, fps: { target: reduced ? 10 : 30 }, scene: [scene] });
  const resize = new ResizeObserver(() => game.scale.resize(Math.max(1, parent.clientWidth * ratio), Math.max(1, parent.clientHeight * ratio))); resize.observe(parent);
  const visibility = () => { if (document.hidden) game.loop.sleep(); else game.loop.wake(); };
  document.addEventListener("visibilitychange", visibility);
  return () => { resize.disconnect(); document.removeEventListener("visibilitychange", visibility); game.destroy(true); canvas.remove(); delete parent.dataset.emblemReady; };
}
